import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const StreakFireIcon = ({ isActive, classObject }) => {
    const iconSrc = isActive ? '/assets/images/on_streak_fire.svg' : '/assets/images/out_streak_fire.svg';
    return React.createElement("img", { src: iconSrc, className: css(styles.icon, classObject) });
};
const styles = StyleSheet.create({
    icon: {
        width: 16,
        height: 16,
    },
});
